(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}).SENTRY_RELEASE = {
  id: "5c4e6a84f2676b5c04afce6ea9bd862d3fa5d9a3"
};